import conf from '../config';
import { getOrganization } from './users';

const initialState = {
  notifications: [],
};

const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
      };

    default:
      return state;
  }
};

const setNotifiactions = notifications => ({
  type: SET_NOTIFICATIONS,
  payload: notifications,
});

export const getNotifications = state => state.notifications.notifications;

export const fetchNotifications = () => async (dispatch, getState) => {
  const state = getState();
  const notifications = getNotifications(state);
  if (notifications.length) return notifications;
  const organization = getOrganization(state);
  const results = await fetch(
    `${conf.apiRoot}/api/notifications?organization=${organization &&
      organization.slug}`,
    {
      credentials: 'include',
    }
  ).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (results) dispatch(setNotifiactions(results));
  return results;
};



// WEBPACK FOOTER //
// ./src/modules/notifications.js